export default __webpack_public_path__ + "static/tres-finocchiaro-4784a9557f4d8c209c25031a8fc7e73e.png";